import isMap from './isMap';
export default function get(key, x) {
  return isMap(x) ? x.get(key) : x[key];
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/get.js
// module id = 1001
// module chunks = 2